import { gql } from '@apollo/client';

export const WORKFLOW_EVENT_SETTING_FRAG = gql`
  fragment WorkflowEventSettingSelection on WorkflowEventSetting {
    id
    isPublished
    visitType
    sendingHours
    appointmentTypes {
      id
      name
    }
    clinicEmployees {
      clinicEmployeeId
      clinicEmployee {
        id
        firstName
        lastName
      }
    }
    clinicRooms {
      clinicRoomId
      clinicRoom {
        id
        name
      }
    }
    actions {
      id
      actionType
      promptType
      config
      order
      channelStatusChangeId
      channelStatusChange {
        id
      }
      workflowEventTriggerDelayInMilliseconds
      workflowEventTrigger
      workflowEventTriggerActionNumber
    }
    automatedTriggerType
    automatedTriggerInMinutes
    clinic {
      id
    }
    event
    groupByWindowInHours
    name
    workflowType
    triggerType
    createdAt
    widgetRequestTypes {
      id
      order
      displayName
      requestType
    }
    triggeringFormTemplates {
      id
      title
    }
    notificationBody
    timeFormat
    surveySettingId
    surveyStep
  }
`;

export const GET_CLINIC_WORKFLOWS_EVENT_SETTINGS = gql`
  query getClinicWorkflowEventSettings($where: WorkflowEventSettingWhereInput) {
    findManyWorkflowEventSetting(where: $where) {
      ...WorkflowEventSettingSelection
    }
  }
  ${WORKFLOW_EVENT_SETTING_FRAG}
`;
export const CREATE_WORKFLOW_EVENT_SETTING = gql`
  mutation createOneWorkflowEventSetting($data: WorkflowEventSettingCreateInput!) {
    createOneWorkflowEventSetting(data: $data) {
      ...WorkflowEventSettingSelection
    }
  }
  ${WORKFLOW_EVENT_SETTING_FRAG}
`;
export const COPY_WORKFLOW_EVENT_SETTING = gql`
  mutation copyOneWorkflowEventSetting($where: WorkflowEventSettingWhereUniqueInput!) {
    copyOneWorkflowEventSetting(where: $where) {
      id
    }
  }
`;
export const DELETE_WORKFLOW_EVENT_SETTING = gql`
  mutation deleteOneWorkflowEventSetting($where: WorkflowEventSettingWhereUniqueInput!) {
    deleteOneWorkflowEventSetting(where: $where) {
      id
    }
  }
`;

export const UPDATE_WORKFLOW_EVENT_SETTING = gql`
  mutation updateOneWorkflowEventSetting(
    $where: WorkflowEventSettingWhereUniqueInput!
    $data: WorkflowEventSettingUpdateInput!
  ) {
    updateOneWorkflowEventSetting(where: $where, data: $data) {
      ...WorkflowEventSettingSelection
    }
  }
  ${WORKFLOW_EVENT_SETTING_FRAG}
`;
